import { render, staticRenderFns } from "./relatorioCad.vue?vue&type=template&id=34a1df20"
import script from "./relatorioCad.vue?vue&type=script&lang=js"
export * from "./relatorioCad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports